import React from 'react';
import ReportViewer from "./base/ReportViewer";

const FeuilletsEnregistrementsNomRemis = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"feuilletsEnregistrementsNomRemis"}/>
        </div>
    );
}
export default FeuilletsEnregistrementsNomRemis;